import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { AllClientLockDateListType } from "../../../redux/listing/listingTypes";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
type AppProps = {
  data: AllClientLockDateListType[] | [];
  tableHeader: TableHeadersType[];
};
const AllClientLockDateTableData = ({ data, tableHeader }: AppProps) => {
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value === "client_name") {
                  let finalName = `${itemData?.client_name} (${itemData?.client_code})`;

                  return <td style={{ minWidth: "194px" }}>{finalName}</td>;
                } else if (item?.value == "expense") {
                  return (
                    <td style={{ minWidth: "194px" }}>
                      {itemData?.expenses_locked_date ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <div style={{ fontWeight: "500" , display:"flex",flexDirection:'column', paddingBottom:'10px'}}>
                            <span style={{ fontWeight: "500", color: "grey" }}>
                              Locked Till:
                            </span>
                            {`
                      ${itemData?.expenses_locked_date}`}
                          </div>

                          {itemData?.expenses_locked_date ? (
                            <span>
                              <span style={{ color: "grey" }}>Updated By:</span>{" "}
                              <UpdatedByAndUpdatedAt
                                firstName={
                                  itemData?.expenses_locked_updated_by
                                    ?.first_name
                                }
                                lastName={
                                  itemData?.expenses_locked_updated_by
                                    ?.last_name
                                }
                                profilePic={
                                  itemData?.expenses_locked_updated_by
                                    ?.profile_pic?.file_url
                                }
                                updatedAt={itemData?.expenses_locked_updated_at}
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        "--/--"
                      )}
                    </td>
                  );
                } else if (item?.value == "revenue") {
                  return (
                    <td style={{ minWidth: "194px" }}>
                      {itemData?.revenues_locked_date ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <div style={{ fontWeight: "500" ,display:"flex",flexDirection:'column', paddingBottom:'10px'}}>
                            <span style={{ fontWeight: "500", color: "grey" }}>
                              Locked Till:
                            </span>
                            {`
                      ${itemData?.revenues_locked_date}`}
                          </div>
                          {itemData?.revenues_locked_date ? (
                            <span>
                              {" "}
                              <span style={{ color: "grey" }}>Updated By:</span>
                              <UpdatedByAndUpdatedAt
                                firstName={
                                  itemData?.revenues_locked_updated_by
                                    ?.first_name
                                }
                                lastName={
                                  itemData?.revenues_locked_updated_by
                                    ?.last_name
                                }
                                profilePic={
                                  itemData?.revenues_locked_updated_by
                                    ?.profile_pic?.file_url
                                }
                                updatedAt={itemData?.revenues_locked_updated_at}
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        "--/--"
                      )}
                    </td>
                  );
                } else if (item?.value == "other") {
                  return (
                    <td style={{ minWidth: "194px" }}>
                      {itemData?.others_locked_date ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <div
                            style={{ fontWeight: "500" ,display:"flex",flexDirection:'column', paddingBottom:'10px'}}
                          >
                            <span style={{ fontWeight: "500", color: "grey" }}>
                              Locked Till:
                            </span>
                            {`
                      ${itemData?.others_locked_date}`}
                          </div>
                          {itemData?.others_locked_date ? (
                            <span>
                              {" "}
                              <span style={{ color: "grey" }}>Updated By:</span>
                              <UpdatedByAndUpdatedAt
                                firstName={
                                  itemData?.others_locked_updated_by?.first_name
                                }
                                lastName={
                                  itemData?.others_locked_updated_by?.last_name
                                }
                                profilePic={
                                  itemData?.others_locked_updated_by
                                    ?.profile_pic?.file_url
                                }
                                updatedAt={itemData?.others_locked_updated_at}
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        "--/--"
                      )}
                    </td>
                  );
                } else if (item?.value == "manufacturingJournal") {
                  return (
                    <td>
                      {itemData?.manufacturing_journal_locked_date ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <div
                            style={{ fontWeight: "500",display:"flex",flexDirection:'column', paddingBottom:'10px' }}
                          >
                            <span style={{ fontWeight: "500", color: "grey" }}>
                              Locked Till:
                            </span>
                            {`
                      ${itemData?.manufacturing_journal_locked_date}`}
                          </div>
                          {itemData?.manufacturing_journal_locked_date ? (
                            <span>
                              <span style={{ color: "grey" }}>Updated By:</span>{" "}
                              <UpdatedByAndUpdatedAt
                                firstName={
                                  itemData
                                    ?.manufacturing_journal_locked_updated_by
                                    ?.first_name
                                }
                                lastName={
                                  itemData
                                    ?.manufacturing_journal_locked_updated_by
                                    ?.last_name
                                }
                                profilePic={
                                  itemData
                                    ?.manufacturing_journal_locked_updated_by
                                    ?.profile_pic?.file_url
                                }
                                updatedAt={
                                  itemData?.manufacturing_journal_locked_updated_at
                                }
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        "--/--"
                      )}
                    </td>
                  );
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default AllClientLockDateTableData;
